// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__zUM1F","green":"Pill_green__GsZB_","yellow":"Pill_yellow__zYFiD","red":"Pill_red__End7h"};